import { axiosClient as axios } from './axiosClient';

import {
  failureResult,
  ResultViewModel,
  successResult,
} from '@models/common/ResultViewModel';
import {
  ShippingAddressResultViewModel,
  ShippingAddressViewModel,
  ShippingTableResultViewModel,
} from '@models/ShippingAddress';
import { handleAxiosError } from '@utils/axiosErrorHandler';
import { getDataUrl } from '@utils/dataUrls';
import { api } from 'src/config/apiEndpoints';

export const ShippingAddressService = {
  create: async function (
    shipping: ShippingAddressViewModel
  ): Promise<ShippingAddressResultViewModel | ResultViewModel> {
    const createUrl = `${api.BASE_URL}${api.SHIPPING_ADDRESSES_ENDPOINT}`;
    try {
      const response = await axios.post(createUrl, shipping);
      return response.data as ShippingAddressResultViewModel;
    } catch (error) {
      return handleAxiosError(error);
    }
  },
  getList: async function (
    page?: number,
    pageSize?: number,
    searchFields?: string,
    search?: string,
    filters?: string,
    sortBy?: string,
    sortDirection?: string
  ): Promise<ShippingTableResultViewModel | ResultViewModel> {
    let dataUrl = getDataUrl(
      api.BASE_URL,
      api.SHIPPING_ADDRESSES_ENDPOINT,
      page,
      pageSize,
      searchFields,
      search,
      sortBy,
      sortDirection
    );
    if (filters) {
      dataUrl = dataUrl + filters;
    }

    try {
      const response = await axios.get(dataUrl);
      return response.data as ShippingTableResultViewModel;
    } catch (error) {
      return handleAxiosError(error);
    }
  },
  getById: async function (
    id: number
  ): Promise<ShippingAddressResultViewModel | ResultViewModel> {
    const dataUrl = `${api.BASE_URL}${api.SHIPPING_ADDRESSES_ENDPOINT}/${id}`;

    try {
      const response = await axios.get(dataUrl);
      return response.data as ShippingAddressResultViewModel;
    } catch (error) {
      return handleAxiosError(error);
    }
  },
  update: async function (
    id: number,
    shipping: ShippingAddressViewModel
  ): Promise<ResultViewModel> {
    const updateUrl = `${api.BASE_URL}${api.SHIPPING_ADDRESSES_ENDPOINT}/${id}`;

    try {
      const response = await axios.put(updateUrl, shipping);
      if (response.status === 204) {
        return successResult;
      }

      return failureResult;
    } catch (error) {
      return handleAxiosError(error);
    }
  },
  delete: async function (id: number): Promise<ResultViewModel> {
    const deleteURL = `${api.BASE_URL}${api.SHIPPING_ADDRESSES_ENDPOINT}/${id}`;

    try {
      const response = await axios.delete(deleteURL);
      if (response.status === 204) {
        return successResult;
      }

      return failureResult;
    } catch (error) {
      return handleAxiosError(error);
    }
  },
};
